import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../../config/config';
import { map } from 'rxjs/operators';

@Injectable()
export class LoginService {

  private URL = AppSettings.API_ENDPOINT;

  constructor(private http: HttpClient) {
  }

  // domain validation  otherwise go to registration
  // /signUp/validateDomain
  validateDomain(domainName, domainSuffix?) {
    const params = { domainName, partnerDomain: domainSuffix };
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(this.URL + '/signUp/validateDomain', params, { headers }).pipe(map(res => res));
  }

  loginValidate(userName, password, domainName) {
    const params = { userName, password, domainName };
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(this.URL + '/login', params, { headers }).pipe(map(res => res));
  }

  staffLogin(userName, password, domainName) {
    const params = { userName, password, domainName };
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(this.URL + '/login/staff', params, { headers }).pipe(map(res => res));
  }

  isValidToken(authToken) {
    const params = {};
    let headers
    if (authToken) {
      headers = new HttpHeaders().append('authToken', authToken);
    }
    else {
      headers = new HttpHeaders();
    }
    return this.http.post(this.URL + '/login/findlogin', params, { headers }).pipe(map(res => res));
  }

  isValidSchoolId(schoolId) {
    const params = { schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json');
    return this.http.post(this.URL + '/login/findSchool', params, { headers }).pipe(map(res => res));
  }

  schoolFranchiseLogin(schoolId, AUTHTOKEN) {
    const params = { schoolId };
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/franchise/school/login', params, { headers }).pipe(map(res => res));
  }

}
